import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextInventory } from '../Inventory';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Category } from '../../../../models/category.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';

export interface ServicePageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  categoriesForCompany: Category[] | null,
  accountingExpenseAccountsForCompany: AccountingAccount[] | null,
  accountingVatAccountsForCompany: AccountingAccount[] | null,
  accountingIncomeAccountsForCompany: AccountingAccount[] | null,
  setCategoriesForCompany: Dispatch<SetStateAction<Category[] | null>>,
  loadSettingsForCompany: Function,
  loadServicesForCompany: Function
};

const ServicePage: React.FunctionComponent<ServicePageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, settingsForCompany, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, setCategoriesForCompany, loadSettingsForCompany, loadServicesForCompany} = UseOutletContextInventory()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, settingsForCompany, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, setCategoriesForCompany, loadSettingsForCompany, loadServicesForCompany}}></Outlet>
  );
}

export function UseOutletContextService() {
  return useOutletContext<ContexType>()
};

export default ServicePage;
